/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiProblem,
  CreateEventTopicRouteRequest,
  InputValidationProblem,
  NotificationEventTopicRoute,
  NotificationEventType,
} from '../models';
import {
    ApiProblemFromJSON,
    ApiProblemToJSON,
    CreateEventTopicRouteRequestFromJSON,
    CreateEventTopicRouteRequestToJSON,
    InputValidationProblemFromJSON,
    InputValidationProblemToJSON,
    NotificationEventTopicRouteFromJSON,
    NotificationEventTopicRouteToJSON,
    NotificationEventTypeFromJSON,
    NotificationEventTypeToJSON,
} from '../models';

export interface CreateEventTopicRouteOperationRequest {
    projectIdOrName: string;
    eventTopicRoute: CreateEventTopicRouteRequest;
}

export interface DeleteEventTopicRouteRequest {
    projectIdOrName: string;
    routeId: string;
}

export interface ListEventTopicRoutesRequest {
    projectIdOrName: string;
    topicId?: string;
    eventType?: NotificationEventType;
}

/**
 * NotificationApi - interface
 * 
 * @export
 * @interface NotificationApiInterface
 */
export interface NotificationApiInterface {
    /**
     * 
     * @summary Create a notification event-topic route
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {CreateEventTopicRouteRequest} eventTopicRoute 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    createEventTopicRouteRaw(requestParameters: CreateEventTopicRouteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationEventTopicRoute>>;

    /**
     * Create a notification event-topic route
     */
    createEventTopicRoute(requestParameters: CreateEventTopicRouteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationEventTopicRoute>;

    /**
     * 
     * @summary Delete a notification event-topic route
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} routeId The event-topic route ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    deleteEventTopicRouteRaw(requestParameters: DeleteEventTopicRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a notification event-topic route
     */
    deleteEventTopicRoute(requestParameters: DeleteEventTopicRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List notification event-topic routes
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} [topicId] Filter by topic ID.
     * @param {NotificationEventType} [eventType] Filter by notification event type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    listEventTopicRoutesRaw(requestParameters: ListEventTopicRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NotificationEventTopicRoute>>>;

    /**
     * List notification event-topic routes
     */
    listEventTopicRoutes(requestParameters: ListEventTopicRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NotificationEventTopicRoute>>;

}

/**
 * 
 */
export class NotificationApi extends runtime.BaseAPI implements NotificationApiInterface {

    /**
     * Create a notification event-topic route
     */
    async createEventTopicRouteRaw(requestParameters: CreateEventTopicRouteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationEventTopicRoute>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling createEventTopicRoute.');
        }

        if (requestParameters.eventTopicRoute === null || requestParameters.eventTopicRoute === undefined) {
            throw new runtime.RequiredError('eventTopicRoute','Required parameter requestParameters.eventTopicRoute was null or undefined when calling createEventTopicRoute.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/notification-event-topic-routes`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEventTopicRouteRequestToJSON(requestParameters.eventTopicRoute),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationEventTopicRouteFromJSON(jsonValue));
    }

    /**
     * Create a notification event-topic route
     */
    async createEventTopicRoute(requestParameters: CreateEventTopicRouteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationEventTopicRoute> {
        const response = await this.createEventTopicRouteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a notification event-topic route
     */
    async deleteEventTopicRouteRaw(requestParameters: DeleteEventTopicRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling deleteEventTopicRoute.');
        }

        if (requestParameters.routeId === null || requestParameters.routeId === undefined) {
            throw new runtime.RequiredError('routeId','Required parameter requestParameters.routeId was null or undefined when calling deleteEventTopicRoute.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/notification-event-topic-routes/{routeId}`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"routeId"}}`, encodeURIComponent(String(requestParameters.routeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a notification event-topic route
     */
    async deleteEventTopicRoute(requestParameters: DeleteEventTopicRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventTopicRouteRaw(requestParameters, initOverrides);
    }

    /**
     * List notification event-topic routes
     */
    async listEventTopicRoutesRaw(requestParameters: ListEventTopicRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NotificationEventTopicRoute>>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling listEventTopicRoutes.');
        }

        const queryParameters: any = {};

        if (requestParameters.topicId !== undefined) {
            queryParameters['topicId'] = requestParameters.topicId;
        }

        if (requestParameters.eventType !== undefined) {
            queryParameters['eventType'] = requestParameters.eventType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/notification-event-topic-routes`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationEventTopicRouteFromJSON));
    }

    /**
     * List notification event-topic routes
     */
    async listEventTopicRoutes(requestParameters: ListEventTopicRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NotificationEventTopicRoute>> {
        const response = await this.listEventTopicRoutesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
